import { render, staticRenderFns } from "./DoubleImageText.vue?vue&type=template&id=2e2a1c6b&"
import script from "./DoubleImageText.vue?vue&type=script&lang=js&"
export * from "./DoubleImageText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports